// The draw canvas's verdict lines, exported so the landing's draw beat and
// taster read the app's own words (landing spec §6).
export const DRAW_VERDICTS = {
    accepted: 'Correct — well drawn.',
    rejected: 'Not quite — compare with the strokes below.',
    overridden: 'Marked as correct.',
} as const
